// extracted by mini-css-extract-plugin
module.exports = {"model-header":"style_model-header__bLvJA","icon":"style_icon__eOjqK","header-content":"style_header-content__2eLqb","title":"style_title__1lPz3"};